// Unternavigation der Verwaltung (nur GQL).
import { NavLink } from 'react-router-dom';

export function VerwaltungReiter() {
  return (
    <nav className="unternav" aria-label="Verwaltung">
      <NavLink to="/verwaltung/lieferungen">Lieferungen</NavLink>
      <NavLink to="/verwaltung/lieferstand">Lieferstand</NavLink>
      <NavLink to="/verwaltung/auswertung">Auswertung</NavLink>
      <NavLink to="/verwaltung/nutzer">Nutzer</NavLink>
    </nav>
  );
}
